import React from 'react';
import { graphql } from 'gatsby';
import LayoutContainer from '../../containers/layout';
import SEO from '../../components/seo';
import './index.scss';
import getPawtnerspageData from '../../normalization/pawtnersPage';

import PartnerLogoGrid from '../../components/PartnersLogoGrid/partnerLogoGrid';
import IntroBanner from '../../components/IntroBanner/introBanner';
import BecomeAPartnerContainer from '../../components/BecomeAPartner/becomeAPartnerContainer';

export const query = graphql`
  query OurPawtnersSitePageQuery {
    site: sanitySiteSettings(_id: { regex: "siteSettings/" }) {
      title
      description
      keywords
    }
  }
`;
const Pawtners = (props) => {
  const pawtnersPageData = getPawtnerspageData();
  const { data } = props;
  const { site } = data || {};

  return (
    <LayoutContainer>
      <SEO title={`${site.title} | Our Pawtners`} description={site.description} keywords={site.keywords} />
      <IntroBanner
        headlineText={pawtnersPageData.imageGallery.headlineText}
        sliderImages={pawtnersPageData.imageGallery.sliderImages}
        description={pawtnersPageData.imageGallery.description}
        layoutStyle={pawtnersPageData.imageGallery.className}
      />
      <PartnerLogoGrid gridData={pawtnersPageData.partnerLogoGrid} />
      <BecomeAPartnerContainer />
    </LayoutContainer>
  );
};
export default Pawtners;
